import { render, staticRenderFns } from "./normally.vue?vue&type=template&id=b1828010&scoped=true&"
import script from "./normally.vue?vue&type=script&lang=js&"
export * from "./normally.vue?vue&type=script&lang=js&"
import style0 from "./normally.vue?vue&type=style&index=0&id=b1828010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1828010",
  null
  
)

export default component.exports